import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-register-parent',
  templateUrl: './register-parent.component.html',
  styleUrls: ['./register-parent.component.scss']
})
export class RegisterParentComponent implements OnInit {

  registerForm: FormGroup;
    currentStep: string = 'register';
    isJotformSubmitted = false;
    isFieldValid = {
        firstName: true,
        lastName: true,
        email: true,
        phone: true,
        password: true,
        confirmPassword: true,
        agreed: true
    };

    constructor(
        private formBuilder: FormBuilder,
        private registrationService: RegistrationService,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            password: ['', [Validators.required, Validators.minLength(12)]],
            confirmPassword: ['', Validators.required],
            agreed: [false, Validators.requiredTrue]
        }, {
            validator: this.MustMatch('password', 'confirmPassword')
        });

        const urlParams = this.getUrlParams();
        if (urlParams.e)
        {
          this.registerForm.controls.email.setValue(urlParams.e);
        }
    }

    
  public getUrlParams(): any {
    const vars = {};
    const target = window.location.href.replace('#', '');
    target.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value): string => {
        vars[key] = decodeURIComponent(value);
        return value;
    });
    return vars;
  }

    getFormValidationErrors(fieldToValidate?: string) {
        var validateAll = fieldToValidate === undefined ? true : false;
        Object.keys(this.registerForm.controls).forEach(key => {
            var isValid = this.registerForm.get(key).status === 'VALID';
            if (!validateAll && fieldToValidate !== key) return;
            switch (key) {
                case 'firstName':
                    this.isFieldValid.firstName = isValid;
                    break;
                case 'lastName':
                    this.isFieldValid.lastName = isValid;
                    break;
                case 'email':
                    this.isFieldValid.email = isValid;
                    break;
                case 'phone':
                    this.isFieldValid.phone = isValid;
                    break;
                case 'password':
                    this.isFieldValid.password = isValid;
                    break;
                case 'confirmPassword':
                    this.isFieldValid.confirmPassword = isValid;
                    break;
                case 'agreed':
                    this.isFieldValid.agreed = isValid;
                    break;
            }
        });
    }

    MustMatch(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];

            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }

            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    registerParent() {
        if (!this.registerForm.valid) {
            this.getFormValidationErrors();
            this.registerForm.markAsTouched();
            return;
        }
        const data = this.registerForm.value;
        if (this.isJotformSubmitted) {
          this.submit();
        } else {
          this.showJotForm(data.email);
        }
    }

    submit() {
      this.spinner.show();

      const data = this.registerForm.value;
      try {
        const theWindow: any = window;
        window['JotForm'].forms[0].submit();
        this.isJotformSubmitted = true;
      }
      catch {

      }

      this.registrationService.registerParent(data).subscribe(
          () => {
              this.spinner.hide();
              window.location.href = '/';
          },
          (err) => {
              this.spinner.hide();
              // RegisterParentAccount refuses with 400 {Message} when the chosen
              // password fails the authentication provider's policy (or the email
              // is taken); the account was NOT created, so just re-prompt.
              this.currentStep = 'register';
              const message = err?.status === 400 && err.error?.Message
                  ? err.error.Message : 'Unable to register. Please try again.';
              setTimeout(() => {
                  const field = document.querySelector('[data-password-feedback]');
                  const handled = field && !field.dispatchEvent(new CustomEvent('rc-password-refused', {
                      detail: message, cancelable: true,
                  }));
                  if (!handled) { alert(message); }
              }, 0);
          }
      );
    }

    showJotForm(email: string) {
        this.currentStep = 'jotform';
        const jotFormIFrame = document.getElementById('JotFormIFrame') as HTMLIFrameElement;
        if (jotFormIFrame) {
            const jotFormSrc = `https://form.jotform.com/242196848710059?email=${encodeURIComponent(email)}`;
            jotFormIFrame.src = jotFormSrc;
        }
    }

    goBackToForm() {
        this.currentStep = 'register';
    }
}
